import styled from 'styled-components';
import { rem } from 'polished';
var LogoContainer = styled.div.withConfig({
  displayName: "LogoContainer",
  componentId: "jm5cli-0"
})(["display:flex;line-height:0;padding:", " 0;"], rem(4));
export default LogoContainer;